import React, { useEffect, useState } from "react";
import Select from "react-select";
import { toast } from "react-toastify";

import { selectCustomStyles } from "../../../../lib/constants";
import { api } from "../../../../utils/axios/Config";
import { cn } from "../../../../utils/utils";

const EditableBankAccount = ({ user_id, value, label, name, className, errors, disabled, type, id }) => {
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");

  const businessType = type === "real" || type === "real/ticket" ? "real" : "legal";

  useEffect(() => {
    fetchOptions();
  }, [searchQuery]);

  useEffect(() => {
    if (options.length > 0 && value) {
      const currentOption = options.find((option) => option.id === value);
      setSelectedOption(currentOption || null);
    }
  }, [options, value]);

  const fetchOptions = async () => {
    try {
      const response = await api.get(`/accounts/?user_id=${user_id}&active_status=true`);
      const fetchedOptions = response.data.items.map((item) => ({
        value: item.account.iban,
        iban: item.account.iban,
        label: item.account.name,
        id: item.account.id,
      }));
      setOptions(fetchedOptions);
    } catch (error) {
      console.error("Error fetching options:", error);
    }
  };

  const updateAccount = async (account_id) => {
    try {
      const response = await api.patch(`/businesses/${businessType}/update/account/${id}/`, {
        account_id: account_id,
      });
      if (response.status === 200) toast.success("حساب با موفقیت تغییر گردید.");
    } catch (error) {
      const errorMessage = error.response?.data?.detail?.message || "خطایی رخ داد";
      toast.error(errorMessage);
      console.error("Error updating account:", error);
    }
  };

  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption);
    updateAccount(selectedOption.id);
  };

  const handleInputChange = (newValue) => {
    setSearchQuery(newValue);
    return newValue;
  };

  const CustomOption = ({ innerRef, innerProps, data, isSelected }) => (
    <div
      ref={innerRef}
      {...innerProps}
      className={`p-2 hover:bg-neutral-20 cursor-pointer ${isSelected ? "bg-neutral-20" : ""}`}
    >
      <div className="font-semibold">{data.label}</div>
      <div className="text-sm text-neutral-50">{data.iban}</div>
      <hr />
    </div>
  );

  return (
    <div className={cn("flex-1 flex flex-col gap-4", className)}>
      <label htmlFor={name}>{label}</label>
      <Select
        styles={selectCustomStyles}
        value={selectedOption}
        options={options}
        isDisabled={disabled}
        components={{ Option: CustomOption }}
        onInputChange={handleInputChange}
        onChange={handleChange}
        placeholder="جستجو..."
        noOptionsMessage={() => "موردی یافت نشد ..."}
      />
      {errors?.message && <div className="text-red-500 text-sm">{errors.message}</div>}
    </div>
  );
};

export default EditableBankAccount;
